var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeIconFIlled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69153 15.3117C3.17837 11.3626 0 9.27075 0 5.94347C0 3.42737 1.7938 1.36475 4.25012 1.36475C5.95467 1.36475 7.21949 2.41156 8.00023 3.89654C8.78091 2.41165 10.0457 1.36475 11.7503 1.36475C14.2069 1.36475 16.0005 3.42777 16.0005 5.94347C16.0005 9.27035 12.8262 11.359 8.30892 15.3116C8.13214 15.4663 7.86829 15.4663 7.69153 15.3117Z",
    fill: "#0741AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIconFIlled);
export default __webpack_public_path__ + "static/media/likeIconFIlled.691ca85f.svg";
export { ForwardRef as ReactComponent };